// extracted by mini-css-extract-plugin
export default {"tooltipText":"TooltipOverrides__tooltipText___z3fk9"};